/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ScoreThresholdTransitionOperator =
  (typeof ScoreThresholdTransitionOperator)[keyof typeof ScoreThresholdTransitionOperator];

export const ScoreThresholdTransitionOperator = {
  gte: "gte",
  gt: "gt",
  lte: "lte",
  lt: "lt",
  eq: "eq",
} as const;
